import './App.css'
import Banner from './components/Banner'
import AboutSection from './components/AboutSection';
import ProjectCards from './components/ProjectCards';
import ContactSection from './components/ContactSection';
import BlogSection from './components/BlogSection';

function App(){
  return (
    <div className = 'App'>
      
      <header>
      <Banner />
      </header>
      <main>
        <section id = "about">
        <AboutSection />
        </section>

        <section id = "projects">
        <ProjectCards />
        </section>
      <div className='bottom-section'>
        <section id = "contact">
        <ContactSection/>
        </section>

        <section id = "blog">
        <BlogSection/>
        </section>
      </div>

      </main>
    </div>
  );
}

export default App;
